import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createStore, updateStore } from './request';
import { STORES_QUERY_KEY } from '@/api/queries/store/key';
import toast from 'react-hot-toast';

export const useCreateStore = (
  onSuccess?: (data: Awaited<ReturnType<typeof createStore>>) => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createStore,
    onSuccess: (data) => {
      toast.success(data.response);
      queryClient.invalidateQueries({ queryKey: [STORES_QUERY_KEY] });
      onSuccess?.(data);
    },
  });
};

export const useUpdateStore = (
  onSuccess?: (data: Awaited<ReturnType<typeof updateStore>>) => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateStore,
    onSuccess: (data) => {
      toast.success(data.response);
      queryClient.invalidateQueries({ queryKey: [STORES_QUERY_KEY] });
      onSuccess?.(data);
    },
  });
};
